import React, { useContext } from 'react';
import { useLocation } from 'react-router-dom';
import { Navigation } from '@shopify/polaris';
import { InventoryIcon } from '@shopify/polaris-icons';
import { AuthenticationContext } from '../../../homeModules/auth/contexts/AuthenticationContext';

const WarehouseSidebar = () => {
  const location = useLocation();
  const { user } = useContext(AuthenticationContext);
  const hasAdminModule = user?.modules?.some((module) => module.value === 'warehouse' && parseInt(module.tier) > 2);

  const subNavigationItems = [
    // On hold: warehouse pickup is not the default entry point.
    // { url: '/warehouse/warehouse_pickup', disabled: false, label: 'Warehouse Pickup' },
    { url: '/warehouse/receiving', disabled: false, label: 'Receiving' },
    { url: '/warehouse/warehouse_options', disabled: false, label: 'Warehouse Options' },
    { url: '/warehouse/notification_config', disabled: false, label: 'Notifications' },
    { url: '/warehouse/label_config', disabled: false, label: 'Label Configuration' },
  ];

  const navigationItems = [
    {
      label: 'Warehouse',
      url: '/warehouse/receiving',
      icon: InventoryIcon as any,
      matches: true,
      subNavigationItems,
    },
  ];

  return (
    <Navigation location={location.pathname}>
      <Navigation.Section items={navigationItems} />
    </Navigation>
  );
};

export default WarehouseSidebar;
